import { render } from "./V3Style.vue?vue&type=template&id=63edd64f&scoped=true"
import script from "./V3Style.vue?vue&type=script&lang=js"
export * from "./V3Style.vue?vue&type=script&lang=js"

import "./V3Style.vue?vue&type=style&index=0&id=63edd64f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63edd64f"]])

export default __exports__